const summary_cards = [
  { label: 'Funding agreements', value: '5', note: 'Grants & donors', accent: 'dark' },
  { label: 'On track', value: '3', note: 'Meeting conditions', accent: 'green' },
  { label: 'Reporting due', value: '1', note: 'Deadline approaching', accent: 'amber' },
  { label: 'Tranche at risk', value: '1', note: 'Payment blocked', accent: 'red' }
];

const filters = [
  { id: 'all', label: 'All', count: 5, active: true },
  { id: 'active', label: 'Active', count: 3 },
  { id: 'reporting-due', label: 'Reporting due', count: 1 },
  { id: 'at-risk', label: 'At risk', count: 1 }
];

const rows_by_tab = {
  all: [
    { ref: 'GR-01', agreement: 'Youth skills development grant', funder: 'Dept of Social Development (DSD)', recipient: 'Skillsforce (provider)', deadline: 'Q2 report - 30 Jun 2026', status: { label: 'On track', class: 'bg-success-subtle text-success-emphasis' } },
    { ref: 'GR-02', agreement: 'NPO community impact grant', funder: 'Corporate CSI donor', recipient: 'NPO implementing partner', deadline: '30 Jun 2026', status: { label: 'At risk', class: 'bg-danger-subtle text-danger-emphasis' } },
    { ref: 'GR-03', agreement: 'Enterprise & supplier development fund', funder: 'SETA / public funding', recipient: 'ESD beneficiaries', deadline: 'Annual - 30 Nov 2026', status: { label: 'On track', class: 'bg-success-subtle text-success-emphasis' } },
    { ref: 'GR-04', agreement: 'Bursary & education funding programme', funder: 'Education trust', recipient: 'Bursary recipients', deadline: 'Close-out - 31 Jul 2026', status: { label: 'Review due', class: 'bg-warning-subtle text-warning-emphasis' } },
    { ref: 'GR-05', agreement: 'Donor health programme grant', funder: 'International donor', recipient: 'Clinic delivery partner', deadline: 'Site visit - 15 Jul 2026', status: { label: 'In progress', class: 'bg-warning-subtle text-warning-emphasis' } }
  ],
  active: [
    { ref: 'GR-01', agreement: 'Youth skills development grant', funder: 'Dept of Social Development (DSD)', recipient: 'Skillsforce (provider)', deadline: 'Q2 report - 30 Jun 2026', status: { label: 'On track', class: 'bg-success-subtle text-success-emphasis' } },
    { ref: 'GR-03', agreement: 'Enterprise & supplier development fund', funder: 'SETA / public funding', recipient: 'ESD beneficiaries', deadline: 'Annual - 30 Nov 2026', status: { label: 'On track', class: 'bg-success-subtle text-success-emphasis' } },
    { ref: 'GR-05', agreement: 'Donor health programme grant', funder: 'International donor', recipient: 'Clinic delivery partner', deadline: 'Site visit - 15 Jul 2026', status: { label: 'In progress', class: 'bg-warning-subtle text-warning-emphasis' } }
  ],
  'reporting-due': [
    { ref: 'GR-04', agreement: 'Bursary & education funding programme', funder: 'Education trust', recipient: 'Bursary recipients', deadline: 'Close-out - 31 Jul 2026', status: { label: 'Review due', class: 'bg-warning-subtle text-warning-emphasis' } }
  ],
  'at-risk': [
    { ref: 'GR-02', agreement: 'NPO community impact grant', funder: 'Corporate CSI donor', recipient: 'NPO implementing partner', deadline: '30 Jun 2026', status: { label: 'At risk', class: 'bg-danger-subtle text-danger-emphasis' } }
  ]
};

export default {
  name: 'ComplyonGrantFundingCompliance',
  data: () => ({
    summary_cards,
    filters,
    active_tab: 'all',
    rows_by_tab
  }),
  computed: {
    rows() {
      return this.rows_by_tab[this.active_tab] || this.rows_by_tab.all;
    }
  },
  methods: {
    set_tab(tab_id) {
      this.active_tab = tab_id;
    }
  }
};
